import { useCallback } from 'react';
import type { Mode } from '../../../../types';
import { useGetEndDate } from './useGetEndDate';
import { useGetStartDate } from './useGetStartDate';

type P = {
  date: Date;
  mode: Mode;
};

export const useGetParamsForEventsQuery = () => {
  const getEndDate = useGetEndDate();
  const getStartDate = useGetStartDate();

  return useCallback(
    ({ date, mode }: P) => ({
      filter: {
        dateFrom: getStartDate({ date, mode }),
        dateTo: getEndDate({ date, mode }),
        pagination: false,
        rsvp: ['going' as const, 'pending' as const],
      },
    }),
    [getEndDate, getStartDate],
  );
};
